var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.356 5.572H6.626l-.849.54l5.975 12.878l.668.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD0124",
    d: "M13.8 12.583c0-.15 0-.227-.128-.3c-.459-.377-.986-.755-1.44-1.132a.27.27 0 0 0-.163-.06a.27.27 0 0 0-.163.06l-1.444 1.205a.4.4 0 0 0-.146.158a.5.5 0 0 0-.051.219a.84.84 0 0 1-.129.454a.38.38 0 0 0 0 .377l2.096 4.924l1.77-4.774c.064-.15.064-.227-.069-.3a1.14 1.14 0 0 1-.128-.831zm-2.25-2.096L7.36 7.341l-.073.077c.073.155.073.232.142.386l1.495 3.45c.142.305.215.613.639.69a.58.58 0 0 0 .356-.077zm.45-.621a.33.33 0 0 0 .373 0c1.419-1.098 2.837-2.113 4.183-3.215c.073-.073.15-.073.15-.154v-.069H7.295a.53.53 0 0 1 .223.15zm.746.621l1.702 1.226c.141.077.355 0 .565 0c.073 0 .142-.15.142-.227c.497-1.23.994-2.533 1.487-3.763c0-.073.073-.15.073-.227h-.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.12 13.727a.977.977 0 0 0 .964-.99a.977.977 0 0 0-.964-.99a.977.977 0 0 0-.965.99c0 .547.432.99.965.99m5.888 0a.977.977 0 0 0 .965-.99a.977.977 0 0 0-.965-.99a.977.977 0 0 0-.964.99c0 .547.432.99.964.99M6.214 7.286a1.071 1.071 0 1 0 0-2.143a1.071 1.071 0 0 0 0 2.143m11.571 0a1.071 1.071 0 1 0 0-2.143a1.071 1.071 0 0 0 0 2.143m-5.571 13.285a1.071 1.071 0 1 0 0-2.143a1.071 1.071 0 0 0 0 2.143"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChz);
export default __webpack_public_path__ + "static/media/chz.44a41cffffa98086cface2139a7d7825.svg";
export { ForwardRef as ReactComponent };